export type OraclePrice = {
  price: number;
  observedAt: number;
  source: string;
  cachedAt: number;
  sampleCount: number;
};

export function cachedOraclePrice(raw: string | null): OraclePrice | null {
  try {
    const value = JSON.parse(raw || "null") as Partial<OraclePrice> | null;
    return value && Number.isFinite(value.price) && value.price! > 0 && Number.isFinite(value.observedAt) && typeof value.source === "string" && Number.isFinite(value.cachedAt) && Number.isFinite(value.sampleCount) ? value as OraclePrice : null;
  } catch { return null; }
}
